export const cmdImport = 'gjs-open-import-webpage';
export const cmdClear = 'canvas-clear';


export const showItineraryTeaserFieldKeys = ["tourism/itinerary"]
